import { render, staticRenderFns } from "./modal-add-product.vue?vue&type=template&id=c516b6a2&"
import script from "./modal-add-product.vue?vue&type=script&lang=js&"
export * from "./modal-add-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports